RivalIQ.module('state', function (state, App, Backbone, Marionette, $, _) {

    'use strict';

    /**
     * The current view state of the application.
     * @type {Backbone.Model}
     */
    const viewState = state.view = new Backbone.Model();

    state.utils.overrideStateSet(viewState, {});

    state.utils.overrideStateGet(viewState, {
        customTimePeriod: state.timePeriods.deserialize,
        timePeriod: state.timePeriods.deserialize,
        landscapeName: _.unescape
    });

    // when a company set is removed, we should check to see if it is active...
    state.companySets.on('remove', function (model) {

        const companySetDescriptor = model.get('id');

        if (companySetDescriptor !== viewState.get('companySetDescriptor')) {

            return;
        }

        // ...and clear the view state companySetDescriptor since it was removed
        viewState.set({
            companySetDescriptor: state.companySets.none
        });
    });

    /**
     * A property map transforming state into view state, and view state
     * into persistence.
     * @type {*[]}
     */
    const statePropertyMap = [
        {
            settingProperty: 'focusCompanyId',
            path: null,
            stateProperty: 'focusCompanyId',
            persistenceProperty: 'focus_company_id'
        },
        {
            settingProperty: 'activeLandscapeId',
            path: null,
            stateProperty: 'landscapeId'
        },
        {
            settingProperty: 'activeLandscapeName',
            stateProperty: 'landscapeName',
            persistenceProperty: 'name',
            path: null
        },
        {
            settingProperty: 'isImpersonating',
            path: null,
            immutable: true
        },
        {
            settingProperty: 'viewStateOverrides',
            stateProperty: 'overrides',
            path: null,
            immutable: true
        },
        {
            settingProperty: 'customTimePeriod',
            path: null
        },
        {
            settingProperty: 'branding',
            path: 'userState',
            immutable: true
        }
    ];

    viewState.getActiveBranding = function () {
        const branding = RivalIQ.utils.branding;
        const active = (RivalIQ.state.account.canCustomizeBranding() ? branding.getActiveBrandingTypeOrDefault() : branding.types.DEFAULT);
        return RivalIQ.utils.branding.getBranding(active);
    };

    /**
     * Returns a boolean indicating if the view state was overridden.
     * @returns {boolean}
     */
    viewState.isOverride = function () {

        const me = this;
        const overrides = me.get('overrides');
        return (_.keys(overrides).length > 0);
    };

    viewState.isExport = function () {
        // headless is "the truth", but it's nice to be able to test
        // export logic/views in a browser as well...

        return RivalIQ.isHeadless || $('body').hasClass('x-export');
    };

    viewState.channelDetails = function () {
        const me = this;
        const channel = me.get('contentChannel');
        const source = RivalIQ.data.CompareData.sources[channel.toUpperCase()];
        return RivalIQ.data.CompareData.sourceDetails[source];
    };

    viewState.channelSorts = function () {
        const me = this;
        const details = me.channelDetails();
        return _.filter(details.validContentSortOrders, function (sort) {
            return !sort.filter;
        });
    };

    viewState.contentSortDetails = function () {
        const me = this;
        return _.find(me.channelSorts(), {
            name: me.get('contentSort')
        });
    };

    viewState.getCompanySetName = function () {
        const me = this;
        return RivalIQ.state.utils.getCompanySetName(me.get('companySetDescriptor'));
    };

    // Ensure that the active content sort always matches a valid sort for the
    // current content channel
    viewState.resetContentSort = function () {
        const me = this;

        if (!me.contentSortDetails()) {
            me.set({
                contentSort: me.channelSorts()[0].name
            });
        }
    };

    viewState.setCustomTimePeriod = function (timePeriod) {
        timePeriod = _.extend({
            id: 'custom'
        }, timePeriod);

        timePeriod.customComparePeriod = true;
        timePeriod.displayString = [
            RivalIQ.formatter.formats.date(timePeriod.mainPeriodStart),
            RivalIQ.formatter.formats.date(timePeriod.mainPeriodEnd)
        ].join(' - ');


        viewState.set({
            customTimePeriod: timePeriod,
            timePeriod: timePeriod
        });
    };

    viewState.getGroupedByInterval = function () {
        const me = this;
        return _.get(me.get('userSessionSettings'), ['groupedByInterval']) || 'auto';
    };

    viewState.temporarilyOverrideGroupedByInterval = function (groupedByInterval) {
        const me = this;

        const userSessionSettings = _.extend({}, _.get(me.get('userSessionSettings')), {
            groupedByInterval: groupedByInterval
        });
        me.set({
            userSessionSettings: userSessionSettings
        });
    };

    /**
     * Persists user view state.
     * @param viewState
     */
    const persistUserViewState = (function () {

        // NOTE keep list of properties in sync with models/user.js

        const userViewStateProperties = [
            {
                from: 'companySetDescriptor',
                to: 'filterSet'
            },
            {
                from: 'timePeriod',
                write: function (state, key, value) {
                    state[key] = value;
                }
            },
            'contentChannel',
            'contentSort',
            'gaConfiguration',
            'interval'
        ];

        function getDefaultWriter(landscapeId) {
            return function (state, key, value) {
                const bucket = state[key] = (state[key] || {});
                bucket[landscapeId] = value;
            };
        }

        function persistenceHandler(state) {
            const properties = viewState.toJSON();
            const landscapeId = properties.landscapeId;
            const defaultWrite = getDefaultWriter(landscapeId);

            _.each(userViewStateProperties, function (userViewStateProperty) {
                const from = _.get(userViewStateProperty, 'from', userViewStateProperty);
                const to = _.get(userViewStateProperty, 'to', from);
                const write = _.get(userViewStateProperty, 'write', defaultWrite);
                write(state, to, properties[from]);
            });

            return {
                userSessionSettings: RivalIQ.state.view.get('userSessionSettings')
            };
        }

        return function (viewState) {

            App.execute('persistence:view:save', persistenceHandler, viewState);
        };

    }());

    /**
     * Initializes view state from properties.
     * NOTE: exposed here on the state object primarily for testing
     * @param properties
     */
    const initializeViewStateFromProperties = viewState.initializeViewStateFromProperties = function (viewState, properties) {

        const data = {};

        _.defaults(properties, _.get(properties.userState, ['landscapes', properties.activeLandscapeId], {}));

        state.utils.initializeState('landscape', 'userState', statePropertyMap, viewState, properties);

        data.landscapeName = _.unescape(viewState.get('landscapeName'));

        const landscapeId = viewState.get('landscapeId');

        let companySetDescriptor = (_.get(properties, ['userState', 'filterSet', landscapeId]) || RivalIQ.state.companySets.none);

        // migrate Only <focus company> companySet to new Only Company B companySet
        if (companySetDescriptor === state.companySets.focus) {
            companySetDescriptor = `${state.companySets.onlyCompany}${properties.focusCompanyId}`;
        } else if (companySetDescriptor) {
            if (!_.isNumber(companySetDescriptor)) {
                companySetDescriptor = _.unescape(companySetDescriptor);
            }
        }

        if (RivalIQ.state.utils.isOnlyCompanySet(companySetDescriptor)) {
            const companyId = RivalIQ.state.utils.getCompanyIdFromSetId(companySetDescriptor);
            // If the show only company set's company was removed from this landscape, revert to all companies.
            if (!RivalIQ.state.landscape.getCompanyById(companyId)) {
                companySetDescriptor = null;
            }
        }

        data.companySetDescriptor = companySetDescriptor;

        viewState.on('change:companySetDescriptor', _.bind(persistUserViewState, null, viewState));

        let timePeriod = state.timePeriods.findWhere({
            default: true
        }).toJSON();
        let landscapeTimePeriods = _.get(properties, 'userState.timePeriod');

        if (landscapeTimePeriods) {
            // NOTE in 5/2019 we decided time periods should follow the user
            // rather than the landscape, so if the version we have here is
            // of the old ways we can tell by the keys of the object (they will
            // all be landscape ids)
            const isLegacy = _.every(_.keys(landscapeTimePeriods), function (key) {
                return _.isFinite(parseInt(key));
            });

            // NOTE per above, if we are in a legacy scenario we want to pull
            // out the current landscape's time period, and use it as the
            // default (this is in part so that users within a session after
            // deployment will not have their time period changed out from
            // under them)
            if (isLegacy) {
                landscapeTimePeriods = _.get(landscapeTimePeriods, [landscapeId]);
            }

            // NOTE if the persisted time period is a number assume it is
            // a duration relative today, otherwise if it is an object then
            // we do the usual deserialization, finally if neither of these
            // cases are true then the default will be used
            if (_.isFinite(landscapeTimePeriods)) {
                timePeriod = App.utils.timePeriod.createTimePeriodFromDuration(landscapeTimePeriods);
            } else if (_.isObject(landscapeTimePeriods)) {
                // NOTE we first try our hand at plucking the time period out
                // of the state time periods by id, so that the dates are
                // calculated relative today for well defined concepts, only
                // if we fail to find the time period should we deserialize
                // the object wholesale (this means that whatever dates are
                // configured will be populated, instead of those that are
                // expanded at run time)
                timePeriod = state.timePeriods.getDefinitionByType(landscapeTimePeriods.id);
                if (!timePeriod) {
                    timePeriod = state.timePeriods.deserialize(landscapeTimePeriods);
                } else {
                    timePeriod.periods = landscapeTimePeriods.periods;
                }
            }
        }

        data.timePeriod = state.timePeriods.updateTimePeriodForTimezone(timePeriod, false);

        viewState.on('change:timePeriod', _.bind(persistUserViewState, null, viewState));

        data.contentChannel = null;
        const contentChannel = _.get(properties, 'userState.contentChannel', {});
        data.contentChannel = contentChannel[landscapeId] || 'twitter';
        viewState.on('change:contentChannel', _.bind(persistUserViewState, null, viewState));

        data.contentSort = null;
        const contentSort = _.get(properties, 'userState.contentSort', {});
        data.contentSort = contentSort[landscapeId] || 'engagement_rate';
        viewState.on('change:contentSort', _.bind(persistUserViewState, null, viewState));

        data.gaConfiguration = null;
        const gaConfiguration = _.get(properties, 'userState.gaConfiguration', {});
        data.gaConfiguration = gaConfiguration[landscapeId];
        viewState.on('change:gaConfiguration', _.bind(persistUserViewState, null, viewState));

        data.interval = null;
        const interval = _.get(properties, 'userState.interval', {});
        data.interval = _.get(interval, landscapeId, RivalIQ.utils.timePeriod.period.day);
        viewState.on('change:interval', _.bind(persistUserViewState, null, viewState));

        data.userSessionSettings = _.get(properties, ['userSessionSettings'], {});
        viewState.on('change:userSessionSettings', _.bind(persistUserViewState, null, viewState));

        // unceremoniously update the view state
        viewState.set(data, {
            silent: true
        });
    };

    (function () {

        let hasInitialized = false;

        viewState.initialize = function (properties) {

            if (hasInitialized) {

                throw 'not supported: view state cannot be initialized more than once.';
            }

            initializeViewStateFromProperties(this, properties);

            hasInitialized = true;

            viewState.listenTo(viewState, 'change:contentChannel', viewState.resetContentSort);
        };

    }());

});
